<div *ngIf="!loading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="regForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Benefício</span>
			</div>
			<app-tab
				*ngIf="!benefitId"
				class="mb-xxs"
				[tabs]="benefitsTabs"
				(action)="onPlanTypeChange($event)"
			></app-tab>
			<div class="d-f line">
				<mat-form-field class="col-2" title="Parceiro" appearance="outline">
					<mat-label>Parceiro</mat-label>
					<mat-select formControlName="partner_id">
						<mat-option
							*ngFor="let partner of partnersByTab"
							[value]="partner.id"
						>
							{{ partner.name }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="regForm.get('partner_id')?.hasError('required')">
						O parceiro é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Cobertura"
					appearance="outline"
					*ngIf="
						regForm.get('type')?.value === 'HEALTH' ||
						regForm.get('type')?.value === 'CONJUGATED'
					"
				>
					<mat-label>Cobertura</mat-label>
					<mat-select formControlName="coverage">
						<mat-option *ngFor="let cov of coverage" [value]="cov">
							{{ cov | titlecase }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="regForm.get('coverage')?.hasError('required')">
						Selecione a cobertura
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-2"
					title="Nome do benefício"
					appearance="outline"
				>
					<mat-label>Nome do benefício</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome do benefício"
						formControlName="name"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="regForm.get('name')?.hasError('required')">
						O nome do plano é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Acomodação"
					appearance="outline"
					*ngIf="
						regForm.get('type')?.value === 'HEALTH' ||
						regForm.get('type')?.value === 'CONJUGATED'
					"
				>
					<mat-label>Acomodação</mat-label>
					<mat-select formControlName="accommodation">
						<mat-option *ngFor="let acc of accommodation" [value]="acc">
							{{ acc | titlecase }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="regForm.get('accommodation')?.hasError('required')">
						Selecione a acomodação
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-2" title="Código ANS" appearance="outline">
					<mat-label>Código ANS</mat-label>
					<input
						type="text"
						matInput
						placeholder="Código ANS"
						formControlName="code_ans"
						id="snf-{{ inputId }}"
					/>
					<mat-error *ngIf="regForm.get('code_ans')?.hasError('required')">
						O código ANS é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Carência ANS"
					appearance="outline"
				>
					<mat-label>Carência ANS</mat-label>
					<mat-select formControlName="lack_ans">
						<mat-option *ngFor="let ans of ansOptions" [value]="ans.value">
							{{ ans.label | titlecase }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="regForm.get('lack_ans')?.hasError('required')">
						Selecione a carência ANS
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="bilForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Regras de faturamento
				</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="col-1 dyn"
					title="Data de início da vigência"
					appearance="outline"
				>
					<mat-label>Data de início da vigência</mat-label>
					<input
						matInput
						formControlName="start_date"
						[matDatepicker]="picker"
					/>
					<mat-datepicker-toggle matSuffix [for]="picker">
						<mat-icon
							matDatepickerToggleIcon
							svgIcon="sanus-calendar-blue"
						></mat-icon>
					</mat-datepicker-toggle>
					<mat-datepicker #picker></mat-datepicker>
					<mat-error>Informe a data da vigência</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Dia do pagamento"
					appearance="outline"
				>
					<mat-label>Dia do pagamento</mat-label>
					<mat-select formControlName="pay_day">
						<mat-option *ngFor="let day of days" [value]="day">
							{{ day }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="bilForm.get('pay_day')?.hasError('required')">
						Informe o dia do pagamento
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Dia de corte da fatura"
					appearance="outline"
				>
					<mat-label>Dia de corte da fatura</mat-label>
					<mat-select formControlName="cutting_day">
						<mat-option *ngFor="let day of days" [value]="day">
							{{ day }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="bilForm.get('cutting_day')?.hasError('required')">
						Informe o dia do corte da fatura
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1"
					title="Pro rata do plano"
					appearance="outline"
				>
					<mat-label>Pro rata do plano</mat-label>
					<mat-select formControlName="pro_rata">
						<mat-option *ngFor="let ans of ansOptions" [value]="ans.value">
							{{ ans.label }}
						</mat-option>
					</mat-select>
					<mat-error *ngIf="bilForm.get('pro_rata')?.hasError('required')">
						Pro rata do plano é obrigatória
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="Demitidos e aposentados"
					appearance="outline"
				>
					<mat-label>Demitidos e aposentados</mat-label>
					<mat-select formControlName="dismiss_retired">
						<mat-option *ngFor="let dr of dis_ret" [value]="dr.value">
							{{ dr.label }}
						</mat-option>
					</mat-select>
					<mat-error
						*ngIf="bilForm.get('dismiss_retired')?.hasError('required')"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="copForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Coparticipação</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="col-1 dyn"
					title="Consultas"
					appearance="outline"
				>
					<mat-label>Consultas</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Consultas"
						formControlName="queries_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuQ"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('queries_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuQ="matMenu">
					<button mat-menu-item (click)="updateInputType('queries_type', 'R$')">
						R$
					</button>
					<button mat-menu-item (click)="updateInputType('queries_type', '%')">
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Exames simples"
					appearance="outline"
				>
					<mat-label>Exames simples</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Exames simples"
						formControlName="simple_exams_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuSE"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('simple_exams_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuSE="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('simple_exams_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('simple_exams_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Exames complexos"
					appearance="outline"
				>
					<mat-label>Exames complexos</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Exames complexos"
						formControlName="complex_exams_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuCE"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('complex_exams_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuCE="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('complex_exams_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('complex_exams_type', '%')"
					>
						%
					</button>
				</mat-menu>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Pronto socorro"
					appearance="outline"
				>
					<mat-label>Pronto socorro</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Pronto socorro"
						formControlName="emergency_room_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuER"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('emergency_room_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuER="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('emergency_room_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('emergency_room_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Internação"
					appearance="outline"
				>
					<mat-label>Internação</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Internação"
						formControlName="hospitalization_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuH"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('hospitalization_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuH="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('hospitalization_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('hospitalization_type', '%')"
					>
						%
					</button>
				</mat-menu>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Terapias"
					appearance="outline"
				>
					<mat-label>Terapias</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Terapias"
						formControlName="therapies_value"
						id="smu-{{ inputId }}"
					/>
					<button
						matSuffix
						mat-icon-button
						class="suffix-align"
						aria-label="Toggle input type"
						[matMenuTriggerFor]="menuT"
					>
						<p class="d-f fd-r ai-fs">
							<span class="input-label">
								{{ copForm.get('therapies_type')?.value }}
							</span>
							<mat-icon svgIcon="sanus-chevron-down-blue"></mat-icon>
						</p>
					</button>
				</mat-form-field>
				<mat-menu #menuT="matMenu">
					<button
						mat-menu-item
						(click)="updateInputType('therapies_type', 'R$')"
					>
						R$
					</button>
					<button
						mat-menu-item
						(click)="updateInputType('therapies_type', '%')"
					>
						%
					</button>
				</mat-menu>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="rmbForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Reembolso</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="col-1 dyn" title="Moeda" appearance="outline">
					<mat-label>Moeda (opcional)</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Moeda (opcional)"
						formControlName="coin"
						id="sfi-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Múltiplo"
					appearance="outline"
				>
					<mat-label>Múltiplo (opcional)</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Múltiplo (opcional)"
						formControlName="multiple"
						id="smu-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="mr-xxxs col-1 dyn mob-va"
					title="Consultas"
					appearance="outline"
				>
					<mat-label>Consultas (opcional)</mat-label>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Consultas (opcional)"
						formControlName="queries"
						id="sco-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="payForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Pagamento do plano</span>
			</div>
			<div class="d-f mb-xs">
				<mat-radio-group
					class="mt-xs line"
					formControlName="average_value"
					(change)="onPaymentTypeChange($event.value)"
				>
					<mat-radio-button color="primary" [value]="true">
						Valor médio
					</mat-radio-button>
					<mat-radio-button color="primary" class="ml-xs no-ml" [value]="false">
						Valor por faixa etária
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="d-f mt-xxs line" *ngIf="payForm.get('average_value')?.value">
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor médio do plano"
					appearance="outline"
				>
					<mat-label>Valor médio do plano</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor médio do plano"
						formControlName="average_value_benefits"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="payForm.get('average_value_benefits')?.hasError('required')"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 0 a 18</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="zero_to_eighteen"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="payForm.get('zero_to_eighteen')?.hasError('required')"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 19 a 23</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="nineteen_to_twenty_three"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('nineteen_to_twenty_three')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 24 a 28</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="twenty_four_to_twenty_eight"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('twenty_four_to_twenty_eight')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 29 a 33</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="twenty_nine_to_thirty_three"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('twenty_nine_to_thirty_three')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 34 a 38</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="thirty_four_to_thirty_eight"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('thirty_four_to_thirty_eight')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 39 a 43</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="thirty_nine_to_forty_three"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('thirty_nine_to_forty_three')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 44 a 48</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="forty_four_to_forty_eight"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('forty_four_to_forty_eight')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 49 a 53</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="forty_nine_to_fifty_three"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('forty_nine_to_fifty_three')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">De 54 a 58</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="fifty_four_to_fifty_eight"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							payForm.get('fifty_four_to_fifty_eight')?.hasError('required')
						"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div
				class="d-f ai-c mt-xxs line"
				*ngIf="payForm.get('value_by_age')?.value"
			>
				<p class="v-fix">A partir de 59</p>
				<mat-form-field
					class="mr-xxxs col-1 dyn"
					title="Valor mensal"
					appearance="outline"
				>
					<mat-label>Valor mensal</mat-label>
					<span class="input-label" matPrefix>R$ &nbsp;</span>
					<input
						type="text"
						matInput
						mask="separator.2"
						decimalMarker=","
						thousandSeparator="."
						placeholder="Valor mensal"
						formControlName="from_fifty_nine"
						id="sco-{{ inputId }}"
					/>
					<mat-error
						*ngIf="payForm.get('from_fifty_nine')?.hasError('required')"
					>
						Este campo é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			class="margin-right-16"
			mat-stroked-button
			color="primary"
			routerLink="../"
		>
			Cancelar
		</button>
		<button
			mat-flat-button
			color="primary"
			[disabled]="shouldDisableSaveBtn()"
			(click)="onSubmit()"
		>
			Cadastrar
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="loading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
